import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    Grid, Typography, Box, TextField, DialogContent, Card, Dialog, DialogTitle, Slider, CardMedia, InputLabel, FormControl, Select, IconButton, MenuItem, CircularProgress
} from '@mui/material';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Pause from '@mui/icons-material/Pause';
import Fullscreen from '@mui/icons-material/Fullscreen';
import CloseIcon from '@mui/icons-material/Close';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import ReusableButton from '../Reusable/PrimaryButton/PrimaryButton';
import VoiceSelector from './VoiceSelector';
import LoaderWithBackdrop from '../Loader/loader';
import { showToast } from '../Toast/CommonToast';
import podcastVoices from '../../services/Podcast.json';
import { uploadFile, getModelName, enhancePrompt, generateSearchVideo, generateVideoId, generateVideoPodcast, enhancePromptVariation } from '../../services/apiService';
import ErrorPopup from '../Popup/ErrorPopup/ErrorPopup';
import { usePodcastWebSocket } from '../../context/PodcastProvider';
import { usePhotoTalksSoket } from '../../context/PhotoTalksProvider';
import CommonPopup from '../Popup/Popup';
import UploadImageCard from '../Reusable/UploadImageCard';
import { VoiceData, VideoItem, UploadState, FormState, VideoState} from "../../services/types";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useLocation } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AspectRatioBox from "../Reusable/AspectRatioDesign";
import YouTubePopup from '../Popup/YouTubePopup/YoutubePopup';
import { useCreditPoints } from '../../services/CreditPointsProvider';
import ExistingUploadImages from "../ExistingImageContainer/ExistingUploadImages";
import FluidComponent from '../Reusable/FluidComponent';
import ScheduledPopup from '../Popup/YouTubePopup/ScheduledPopup';
import UserProfileHeader from "./UserProfileView";
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';

interface ImageId {
  _id: string;
  url: string;
  caption: string;
  inputData?: {
    prompt?: string;
  };
  usedPrompt?: string; 
}


function PodCast() {
    const [viewType, setViewType] = useState<'grid' | 'masonry'>('masonry');
    const [errorPopupOpen, setErrorPopupOpen] = useState({ open: false, message: "" });
    const [upload, setUpload] = useState<UploadState>({ image: null, file: null, loading: false });
    const [form, setForm] = useState<FormState>({ prompt: '', script: '', aspectRatio: '1:1', resolution: '540p', voiceId: '' });
    // Video state now only contains playback-related info
    const [video, setVideo] = useState<VideoState>({ duration: 0, progress: 0, playing: false, fullscreen: false });
    // Separate state for mainVideo and thumbnail
    const [mainVideo, setMainVideo] = useState<string | null>(null);
    const [thumbnail, setThumbnail] = useState<string | null>(null);
    const [allSearchImages, setAllSearchImages] = useState<VideoItem[]>([]);
    const [selectedVideoIndex, setSelectedVideoIndex] = useState<number>(0);
    const [voices, setVoices] = useState<any[]>([]);
    const [audio, setAudio] = useState<HTMLAudioElement | null>(null);
    const [playingVoiceId, setPlayingVoiceId] = useState<string | null>(null);
    const [modelIdDetails, setModelIdDetails] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isWsLoading, setIsWsLoading] = useState<boolean>(false);
    const userId = localStorage.getItem('userId') || '';
    const fileInputRef = useRef<HTMLInputElement>(null);
    const videoRef = useRef<HTMLVideoElement>(null);
    const location = useLocation();
    const photoTalksPage = location.pathname.startsWith('/studio/photo-talks');
    const photoTalksSocket = usePhotoTalksSoket();  //photoTalks socket
    const podcastSocket = usePodcastWebSocket(); //podcast socket
    const { responseData, reconnectWebSocket, status } = photoTalksPage ? photoTalksSocket : podcastSocket;
    const [popupOpen, setPopupOpen] = useState<boolean>(false);
    const [selectedPopupItem, setSelectedPopupItem] = useState<VideoItem | null>(null);
    const { state } = location;
  const [selectedImageId, setSelectedImageId] = React.useState<ImageId | null>(null);
   const photoTalksText = location.pathname.startsWith('/studio/photo-talks')
    const { fetchCreditPoints } = useCreditPoints();
    const [scheduledData, setScheduledData] = useState<any[] | null>(null);
    const [userProfileIcon, setUserProfileIcon] = useState(false)
       const [voiceDetails, setVoiceDetails] = useState<any>(null);
       const [voiceType, setVoiceType] = useState('');
          // Model/credit info
const modelId = photoTalksPage
  ? modelIdDetails.find((item: any) => item.eventName === 'Photo Talks')?._id
  : modelIdDetails.find((item: any) => item.eventName === 'Podcast')?._id;
    const podcastResultionCredits = modelIdDetails.find((item: any) => item.eventName === "Photo Talks")?.videoCreditsPerSecond?.[form.resolution] || "";
    useEffect(() => {
      if (modelId) localStorage.setItem("podcastModelId", modelId);
    }, [modelId]);
  
    // Only auto-upload when selectedImageId.url actually changes (not just prompt/caption)
    const lastUploadedUrlRef = React.useRef<string | null>(null);
    useEffect(() => {
        const uploadImageFromUrl = async () => {
            if (selectedImageId?.url && selectedImageId.url !== lastUploadedUrlRef.current) {
                setIsLoading(true);
                try {
                    const response = await fetch(selectedImageId.url);
                    const blob = await response.blob();
                    const urlParts = selectedImageId.url.split('.');
                    const ext = urlParts.length > 1 ? urlParts[urlParts.length - 1].split('?')[0] : 'jpg';
                    const fileName = `selectedImage.${ext}`;
                    const fileFromUrl = new File([blob], fileName, { type: blob.type });
                    const formData = new FormData();
                    formData.append('files', fileFromUrl);
                    formData.append('userId', userId);
                    formData.append('eventId', modelId);
                    formData.append('isStudioImage', 'true');
                    const uploadResponse = await uploadFile(formData);
                    if (uploadResponse?.status === 'success') {
                        setUpload(u => ({ ...u, image: uploadResponse.data[0].url }));
                        setForm(f => ({ ...f, prompt: uploadResponse.data[0]?.caption || '' }));
                        showToast(uploadResponse.message, 'success');
                    } else {
                        showToast(uploadResponse.message, 'error');
                    }
                    lastUploadedUrlRef.current = selectedImageId.url;
                } catch (error:any) {
                    showToast(error?.message, 'error')
                } finally {
                    setIsLoading(false);
                }
            }
        };
        if (selectedImageId?.url && selectedImageId.url !== lastUploadedUrlRef.current) {
            uploadImageFromUrl();
        }
        // Only run when selectedImageId?.url changes
    }, [selectedImageId?.url, userId, modelId]);

// useEffect(() => {
//   if (selectedImageId) {
//     setForm(f => ({ ...f, prompt: selectedImageId?.inputData?.prompt || selectedImageId?.usedPrompt || '' }));
//   }
// }, [selectedImageId]);

    // Restore video popup by id after redirect
React.useEffect(() => {
    const youtubeLocation = localStorage.getItem('youtubeId');
    const locationPage = localStorage.getItem('youtubeLocation');
    if (youtubeLocation && allSearchImages.length > 0 && locationPage && state?.popup) {
        const idx = allSearchImages.findIndex(item => item._id === youtubeLocation);
        if (idx !== -1) {
            setSelectedVideoIndex(idx);
            setSharePopup(true);
            setSelectedPopupItem(allSearchImages[idx]);
        }
        localStorage.removeItem('youtubeLocation');
    }
}, [location.pathname, allSearchImages, state?.popup]);



    const [sharePopup, setSharePopup] = useState<boolean>(false);
    const [publishedData, setPublishedData] = useState<any>(null);
    const [viewPopupOpen, setViewPopupOpen] = useState<boolean>(false);

       const handleOpenPopup = (item: any) => {
        console.log("handleOpenPopup item:", item);
        setPopupOpen(true);
        setSelectedPopupItem(item);
    }

    const handleSharePopup = (item: any) => {
        setSharePopup(true);
        setSelectedPopupItem(item);
        localStorage.setItem('youtubeLocation', location.pathname)
        localStorage.setItem('youtubeId', item._id);
    }


    const photoTalksId = modelIdDetails.find((item: any) => item.eventName === 'Photo Talks')?._id;
    localStorage.setItem('photoTalksModelId', photoTalksId || '');



    const normalizedVoices = useMemo(
      () =>
        (podcastVoices as any[]).map((v) => ({
          ...v,
          _id: v.voice_id,
          previewUrl: v.previewUrlBlob,
        })),
      []
    );

    // Fetch voices and model info
    useEffect(() => {
      setVoices(normalizedVoices);
    }, [normalizedVoices]);
    useEffect(() => {
      (async () => {
        try {
          const response = await getModelName("video");
          if (response?.status === "success") setModelIdDetails(response.data);
        } catch {}
      })();
    }, []);

    const websoketResponse = status === "IN_PROGRESS";
    // WebSocket: update search images
    useEffect(() => {
        if (responseData) {
            setIsWsLoading(false);
            const responseArray = Array.isArray(responseData) ? responseData : [responseData];
            setIsWsLoading(false);
            if (responseArray.length > 0) {
                setAllSearchImages(prev => {
                    const safePrev = Array.isArray(prev) ? prev : [];
                    const filtered = safePrev.filter(item => item.status !== 'IN_PROGRESS');
                    return [...responseArray, ...filtered];
                });
                fetchCreditPoints(userId);
            }
        }
    }, [responseData, status, userId, fetchCreditPoints]);

    // Fetch all images for model
    useEffect(() => {
    if (!userId || !modelId) return; 
    (async () => {
        const payLoadSearch = {
            userId: userId,
            eventId: modelId,
        }
        try {
            const response = await generateSearchVideo(payLoadSearch);
            if (response.status === 'success') {
                setAllSearchImages(response.data);
                setMainVideo(response?.data[0]?.videoUrl || response?.data[0]?.projectStatusResponse?.url || null);
                setThumbnail(response?.data[0]?.thumbnailUrl || null);
                setScheduledData(response?.scheduledYouTubeUpdates)
            }
        } catch { }
    })();
}, [status, responseData, userId, modelId, isLoading, sharePopup]);
    

    // Select first video on new search
    useEffect(() => { if (allSearchImages.length) setSelectedVideoIndex(0); }, [allSearchImages]);
    // Update video and image on selection
    useEffect(() => {
        if (allSearchImages.length && allSearchImages[selectedVideoIndex]) {
            setMainVideo(allSearchImages[selectedVideoIndex].videoUrl || null);
            setThumbnail(allSearchImages[selectedVideoIndex].thumbnailUrl || null);
            const published = allSearchImages[selectedVideoIndex]?.published;
            let youtubeDataArr: any[] = [];
            if (published && typeof published === 'object' && Array.isArray(published.youtube) && published.youtube.length > 0) {
                youtubeDataArr = published.youtube;
            }
            setPublishedData(youtubeDataArr);
        }
        if (allSearchImages[selectedVideoIndex]?.status === 'ERROR') {
            showToast(allSearchImages[selectedVideoIndex]?.projectStatusResponse?.errorMessage ||  'error');
        }
    }, [selectedVideoIndex, allSearchImages, responseData]);

    // Video controls
    useEffect(() => {
        const videoEl = videoRef.current;
        if (!videoEl) return;
        const handlePlay = () => setVideo(v => ({ ...v, playing: true }));
        const handlePause = () => setVideo(v => ({ ...v, playing: false }));
        videoEl.addEventListener('play', handlePlay);
        videoEl.addEventListener('pause', handlePause);
        return () => {
            videoEl.removeEventListener('play', handlePlay);
            videoEl.removeEventListener('pause', handlePause);
        };
    }, []);

    // Audio controls
    useEffect(() => () => { if (audio) audio.pause(); }, [audio]);
    const handlePlayPauseVoice = (voice: VoiceData) => {
        setForm(f => ({ ...f, voiceId: voice.voice_id ?? '' }));
        if (audio && playingVoiceId === voice.voice_id) {
            audio.pause(); setPlayingVoiceId(null);
        } else {
            if (audio) audio.pause();
            const newAudio = new window.Audio(voice.previewUrl);
            setAudio(newAudio); setPlayingVoiceId(voice._id);
            newAudio.play(); newAudio.onended = () => setPlayingVoiceId(null);
        }
    };

    // Upload
    const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsLoading(true);
        const files = e.target.files;
        if (!files || files.length === 0) return;
        setUpload(u => ({ ...u, file: files[0] }));
        const formData = new FormData();
        formData.append('files', files[0]);
        formData.append('userId', userId);
        formData.append('eventId', modelId);
        formData.append('isStudioImage', 'true');
        try {
            const response = await uploadFile(formData);
            if (response?.status === 'success') {
                setUpload(u => ({ ...u, image: response.data[0].url }));
                setForm(f => ({ ...f, prompt: response.data[0]?.caption || '' }));
                showToast(response.message, 'success');
            } else {
                showToast(response.message, 'error');
            }
        } catch (error: any) {
            showToast(error.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    // Enhance prompt
    const handleEnhanceWithAI = async () => {
        setIsLoading(true);
        try {
            const payLoadPrompt = { prompt:  selectedImageId?.inputData?.prompt || form.prompt, eventId: modelId };
            const enhancePromptResponse = await enhancePrompt(payLoadPrompt);
            if (enhancePromptResponse.status === 'success') {
                if (selectedImageId) {
                    // Update the selectedImageId with the enhanced prompt
                    setSelectedImageId({
                        ...selectedImageId,
                        usedPrompt: enhancePromptResponse.data,
                        inputData: {
                            ...selectedImageId.inputData,
                            prompt: enhancePromptResponse.data
                        }
                    });
                } else {
                    setForm(f => ({ ...f, prompt: enhancePromptResponse.data }));
                }
            }
        } finally {
            setIsLoading(false);
        }
    };
       const handleVariationWithAI = async () => {
            setIsLoading(true);
            try {
                const payloadVariation = {
                    prompt: selectedImageId?.inputData?.prompt || form.prompt,
                    eventId: modelId,
                    imageUrl: upload ? upload.image || selectedImageId?.url || "" : ""
                };
                const response = await enhancePromptVariation(payloadVariation);
                setIsLoading(false);
                if (response && response.status === "success") {
                    if (selectedImageId) {
                        setSelectedImageId({
                            ...selectedImageId,
                            usedPrompt: response.data,
                            inputData: {
                                ...selectedImageId.inputData,
                                prompt: response.data
                            }
                        });
                    } else {
                        setForm(f => ({ ...f, prompt: response.data }));
                    }
                    showToast(response.message, "success");
                } else {
                    showToast(response.message, "error");
                    setIsLoading(false);
                }
            } catch (error: any) {
                setIsLoading(false);
                showToast(error.message, "error");
            }
        };

    // Generate podcast
    const handleGeneratePodcast = async () => {
        reconnectWebSocket();
        setIsWsLoading(true);
        if (!selectedImageId?.url && !upload.file) return showToast('Please upload an image', 'error');
        try {
            const formData = new FormData();
            // If selectedImageId.url exists, fetch and append as file
            if (selectedImageId?.url) {
                try {
                    const response = await fetch(selectedImageId.url);
                    const blob = await response.blob();
                    const urlParts = selectedImageId.url.split('.');
                    const ext = urlParts.length > 1 ? urlParts[urlParts.length - 1].split('?')[0] : 'jpg';
                    const fileName = `selectedImage.${ext}`;
                    const fileFromUrl = new File([blob], fileName, { type: blob.type });
                    formData.append('files', fileFromUrl);
                } catch (err) {
                    showToast('Failed to fetch selected image', 'error');
                }
            }
            if (upload.file) {
                formData.append('files', upload.file);
            }
            formData.append('eventId', modelId);
            formData.append('userId', userId);
            formData.append('prompt', form.prompt );
            formData.append('script', form.script);
            formData.append('aspectRatio', form.aspectRatio);
            formData.append(
  'voiceId',
  userProfileIcon === false && voiceDetails && voiceDetails.voiceId
    ? voiceDetails.voiceId
    : form.voiceId
);
            formData.append('creditsPoints', podcastResultionCredits ?? '');
            formData.append('isStudioImage', 'true');
            formData.append('resolution', form.resolution);
             // Only append isCloned if Human Persona is selected
        if (voiceDetails?.voiceId && userProfileIcon === false) {
  formData.append('isCloned', 'true');
}
            setIsLoading(true);
            const response = await generateVideoPodcast(formData);
            setIsLoading(false);
            fetchCreditPoints(userId);
            const is404 = response?.statusCode === 404 || response?.errcode === "CRD404";
            const is403 = response?.statusCode === 403  || response?.errcode === "CRD403";
            if (response.status === 'success') { 
                setAllSearchImages(response.data);
                setMainVideo(response?.data?.videoUrl || response?.data?.projectStatusResponse?.url || null);
                setThumbnail(response?.data.thumbnailUrl || null);
                setUpload({ image: null, file: null, loading: false });
                setSelectedImageId(null);
                setForm({ prompt: '', script: '', aspectRatio: '1:1', resolution: '540p', voiceId: '' });
                showToast(response.message, 'success');
                setUserProfileIcon(true);
            } else if (is404 || is403 || response?.errcode) {
                setErrorPopupOpen({
                    open: true,
                    message: response?.message || "Failed to generate podcast.",
                });
            } else {
                showToast(response?.message || "Failed to generate podcast.", "error");
            }
        } catch (error: any) {
            console.log("error", error)
            setIsLoading(false);
            showToast(error?.message || "Failed to generate podcast.", "error");
            setErrorPopupOpen({
                open: true,
                message: error?.message || "Failed to generate podcast.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Video helpers
    const handleProgress = () => {
        if (videoRef.current) {
            const { currentTime, duration } = videoRef.current;
            if (!isFinite(currentTime) || !isFinite(duration) || duration === 0) return;
            setVideo(v => ({ ...v, progress: (currentTime / duration) * 100, duration }));
        }
    };
    const handleSeek = (_e: Event, newValue: number | number[]) => {
        if (videoRef.current) {
            const duration = videoRef.current.duration;
            if (!isFinite(duration)) return;
            const seekValue = Array.isArray(newValue) ? newValue[0] : newValue;
            videoRef.current.currentTime = (seekValue / 100) * duration;
            setVideo(v => ({ ...v, progress: seekValue }));
        }
    };
    const formatTime = (t: number) => `${Math.floor(t / 60)}:${Math.floor(t % 60).toString().padStart(2, '0')}`;
    const togglePlayPause = async () => {
    if (videoRef.current) {
        const videoEl = videoRef.current;
        if (video.playing && !videoEl.paused) {
            videoEl.pause();
            setVideo(v => ({ ...v, playing: false }));
        } else if (!video.playing && videoEl.paused) {
            try {
                await videoEl.play();
                setVideo(v => ({ ...v, playing: true }));
            } catch (err) {
                // Autoplay might be blocked or interrupted, handle gracefully
                console.warn("Play request interrupted or blocked:", err);
            }
        }
    }
};
      const handleDownload = async () => {
        let fileUrl = mainVideo || "";
        if (!fileUrl.startsWith("http://") && !fileUrl.startsWith("https://") && !fileUrl.startsWith("/")) {
            showToast("Invalid file URL for download.", "error");
            return;
        }
        let fileName = fileUrl.split('/').pop()?.split('?')[0] || "podcast-video.mp4";
        if (!fileName.toLowerCase().endsWith('.mp4')) {
            fileName += '.mp4';
        }
        if (!mainVideo) {
            console.error("Missing video.");
            return;
        }
        try {
            const response = await fetch(mainVideo);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };
    const handleButtonClick = () => fileInputRef.current && fileInputRef.current.click();
    const handleVideoSearch = async (id: string) => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
            setVideo(v => ({ ...v, progress: 0, playing: false }));
        }
        try {
            const apiResponse = await generateVideoId(id);
            if (apiResponse.status === 'success') {
                setMainVideo(apiResponse.data?.videoUrl || null);
                setThumbnail(apiResponse.data?.thumbnailUrl || null);
                // Wait for metadata to load before playing
                if (videoRef.current) {
                    const videoEl = videoRef.current;
                    const playAfterLoaded = async () => {
                        try {
                            await videoEl.play();
                            setVideo(v => ({ ...v, playing: true }));
                        } catch (err) {
                            // Autoplay might be blocked, ignore
                        }
                        videoEl.removeEventListener('loadedmetadata', playAfterLoaded);
                    };
                    videoEl.addEventListener('loadedmetadata', playAfterLoaded);
                }
            }
            if (apiResponse.status === 'ERROR' || apiResponse.data?.status === 'ERROR') {
                showToast(
                    apiResponse.data?.projectStatusResponse?.errorMessage ||
                    apiResponse.projectStatusResponse?.errorMessage ||
                    'error'
                );
            }
        } catch {}
    };

    console.log('voiceDetails', voiceDetails, userProfileIcon);

    
    // Render
    return (
        <Grid className='podcastContainer'>
            {isLoading && <LoaderWithBackdrop open={isLoading} />}
            {(errorPopupOpen.open && (errorPopupOpen.message === "Credits not found" || errorPopupOpen.message === "Insufficient credits")) && (
                <ErrorPopup
                    open={errorPopupOpen.open}
                    message={errorPopupOpen.message}
                    onClose={() => setErrorPopupOpen({ open: false, message: "" })}
                />
            )}
            <Box>
                <Typography variant='h1' gutterBottom className='studioNavHeading'>Generate {photoTalksPage ? 'Phototalks' : 'Podcast'} in seconds</Typography>
            </Box>
            <Grid container spacing={1} className='podcastMainContainer' sx={{
  gap: { xs: 0, sm: 0, md: 0 },
  padding: { xs: 0, sm: 0, md: 2 },
  margin: 0,
  width: '100%',
  flexWrap: 'wrap',
}}>
                <Grid item xs={12} sm={6} md={5} className='podcastCardleft' sx={{ p: { xs: 0, sm: 0, md: 0 }, m: 0 }}>
                    <Box className='uploadImageContainer'>
                        <Box>
                                                        <Box
                                                            className='width100'
                                                            sx={{ height: '175px'}}
                                                            onDrop={async (e) => {
                                                                e.preventDefault();
                                                                try {
                                                                    const data = e.dataTransfer.getData('application/json');
                                                                    if (data) {
                                                                        const image = JSON.parse(data);
                                                                        setSelectedImageId(image);
                                                                        setUpload(u => ({ ...u, image: image.url }));
                                                                        setForm(f => ({ ...f, prompt: image.caption || '' }));
                                                                    }
                                                                } catch (err) {
                                                                    // ignore
                                                                }
                                                            }}
                                                            onDragOver={e => e.preventDefault()}
                                                        >
                                                                <UploadImageCard
                                                                        image={upload.image}
                                                                        onDelete={() => { setUpload({ image: null, file: null, loading: false }); setForm(f => ({ ...f, prompt: '' })); selectedImageId && setSelectedImageId(null); }}
                                                                        onUploadClick={handleButtonClick}
                                                                        onFileChange={handleUpload}
                                                                        fileInputRef={fileInputRef}
                                                                        setSelectedImageId={setSelectedImageId}
                                                                        selectedImageId={selectedImageId}
                                                                        setVoiceDetails={setVoiceDetails}
                                                                        setVoiceType={setVoiceType}
                                                                        voiceDetails={voiceDetails}
                               setUserProfileIcon={setUserProfileIcon}

                                                                />
                                                        </Box>
                            <Box className='width100'>
                                <Box className='promptHeader'>
                                 <div className='promptHeaderText'>
                                    <img src={'/assets/scriptIcon.svg'} alt='scriptIcon' className='scriptIcon' />
                                    <Typography variant='h6' gutterBottom className='uploadText'>{photoTalksPage ? `Describe your phototalks video` : `Describe your podcast video`}</Typography>
                                </div>
                                <div className='promptHeaderText'>
                                     <ReusableButton icon={<AutoAwesomeIcon className="variationIcon" />} onClick={handleVariationWithAI} disabled={!prompt || !upload?.image }>Variant with AI</ReusableButton>
                                <ReusableButton 
                                  onClick={handleEnhanceWithAI} 
                                 disabled={!prompt || !upload?.image}
                                  icon={<AutoAwesomeIcon className="enhanceIcon" />}
                                >
                                  Enhance With AI
                                </ReusableButton>
                                </div>
                            </Box>
                                <TextField fullWidth className='textField' variant='outlined' label='Enhance your character prompt with emotions and gestures...' value={selectedImageId?.inputData?.prompt || selectedImageId?.usedPrompt || form.prompt} multiline rows={form?.prompt ? 3 : 2} onChange={e => {
                                    setForm(f => ({ ...f, prompt: e.target.value }));
                                    setSelectedImageId(prev => prev ? { ...prev, inputData: { ...prev.inputData, prompt: e.target.value } } : null);
                                }} sx={{mt: 1}}/>
                            </Box>
                        </Box>
                        <Box className='promptHeader'>
                                <div className='promptHeaderText'>
                                    <GraphicEqIcon className='graphicIcon' />
                                    <Typography variant='h6' gutterBottom className='uploadText'>Add audio script: text and voice both required.</Typography>
                                </div>
                            </Box>

                        <Box className='podcastVoiceContainer'>
                            {voiceDetails && !userProfileIcon && (
                                <Box className='width50' sx={{mb: 2}}>
                                 <UserProfileHeader 
                               name = {voiceDetails.name}
                               accentName = {voiceDetails?.labels?.accent}
                               previewUrl = {voiceDetails.previewAudioUrl}
                               setUserProfileIcon={setUserProfileIcon}
                               />
                            </Box>
                            )}                            
                            <Box className={  !voiceDetails || userProfileIcon ? 'width100' : 'width50'} sx={{mb: 2}}>
                                <VoiceSelector
                                    voices={voices}
                                    handlePlayPauseVoice={handlePlayPauseVoice}
                                    playingVoiceId={playingVoiceId}
                                    selectedVoice={form.voiceId}
                                    onVoiceChange={(voiceId) => setForm(f => ({ ...f, voiceId }))}
                                />
                            </Box>
                        </Box>
                        <Box className='inputView' sx={{position: 'relative', p: 0}}>
                            <TextField fullWidth className='textField' variant='outlined' label='Write your script here, and it will generate text from your input...' required value={form.script} multiline rows={form?.script ? 5 : 5} onChange={e => setForm(f => ({ ...f, script: e.target.value }))} />
                                { voiceType ==='Person' && (
                                    <Box sx={{ position: 'absolute', bottom: '1px', left: '1px' }}>
                                    <Typography sx={{
                                        backgroundColor: '#70319D',
                                        padding: '4px 8px',
                                        borderRadius: '0px 10px 0px 10px',
                                        color: '#fff',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '4px',
                                    }}>
                                        <DiamondOutlinedIcon  sx={{ fontSize: '12px' }} />
                                        25 credits upto 1000 words
                                    </Typography>
                                    </Box>)}
                        </Box>
                        <div className='podcastButtonContainer'>
                            <Box className='aspectRatio width50'>
                                <FormControl fullWidth className='textField'>
                                    <InputLabel>Aspect Ratio</InputLabel>
                                    <Select value={form.aspectRatio} onChange={e => setForm(f => ({ ...f, aspectRatio: e.target.value as string }))} label='Aspect Ratio'
                                        renderValue={(selected) => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {selected}
            </Box>
        )}
                                    >
                                        <MenuItem value='1:1' className='selectBtn'>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <AspectRatioBox ratio='1:1' isSelected={form.aspectRatio === '1:1'} />
                                                    1:1
                                                </Box>
                                                {form.aspectRatio === '1:1' && <CheckCircleIcon color="success" fontSize="small" />}
                                            </Box>
                                        </MenuItem>
                                        <MenuItem value='16:9' className='selectBtn'>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <AspectRatioBox ratio='16:9' isSelected={form.aspectRatio === '16:9'} />
                                                    16:9
                                                </Box>
                                                {form.aspectRatio === '16:9' && <CheckCircleIcon color="success" fontSize="small" />}
                                            </Box>
                                        </MenuItem>
                                        <MenuItem value='9:16' className='selectBtn'>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <AspectRatioBox ratio='9:16' isSelected={form.aspectRatio === '9:16'} />
                                                    9:16
                                                </Box>
                                                {form.aspectRatio === '9:16' && <CheckCircleIcon color="success" fontSize="small" />}
                                            </Box>
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth className='textField'>
                                    <InputLabel>Resolution</InputLabel>
                                    <Select value={form.resolution} onChange={e => setForm(f => ({ ...f, resolution: e.target.value as string }))} label='Resolution'
                                        >
                                        <MenuItem value='720p'>720p</MenuItem>
                                        <MenuItem value='540p'>540p</MenuItem>
                                        {/* <MenuItem value='Auto'>Auto</MenuItem> */}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box className='GenerateButtonContainer width50'>
                                <ReusableButton  disabled={!(selectedImageId?.inputData?.prompt || selectedImageId?.usedPrompt || form.prompt || form?.script)} onClick={handleGeneratePodcast}>
                                   Generate ({podcastResultionCredits || 0} Credits / per sec)
                                </ReusableButton>
                            </Box>
                           
                        </div>
                         <Box className='podcastUpload-Container'>
                                <ExistingUploadImages modelId={modelId} setForm={setForm} setUpload={setUpload} upload={upload}/>
                            </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={7} className='podcastCardRight' sx={{ p: { xs: 0, sm: 0, md: 0 }, m: 0 }}>
                    {(allSearchImages && allSearchImages.length > 0 && allSearchImages.some(item => item.videoUrl || item.thumbnailUrl)) ? (
                        <Box>
                            {mainVideo ? (
                                <Box className='videoCard'>
                                    <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 , flexDirection: 'row' }}>
                                         <Box className=''>
                                        <IconButton onClick={() => setViewPopupOpen(true)}>
                                           <img src={'/assets/VideoEye.svg'} alt='viewIcon' className='' />
                                        </IconButton>
                                    </Box>
                                    <Box className=''>
                                        <IconButton onClick={handleDownload}>
                                            <img src={'/assets/DownloadIcon.svg'} alt='downloadIcon' className='' />
                                        </IconButton>
                                    </Box>
                                     <Box className=''>
                                                            <IconButton onClick={() => handleSharePopup(allSearchImages[selectedVideoIndex])}>
                                                                <img src={'/assets/ShareIcon.svg'} alt='shareIcon' className='' />
                                                            </IconButton>
                                                        </Box>
                                        </Box>
                                    <Box className='videoWrapper'>
                                        <video key={thumbnail || undefined} ref={videoRef} loop onTimeUpdate={handleProgress} playsInline onLoadedMetadata={handleProgress} poster={thumbnail || ''} style={{ width: '100%' }}>
                                            <source src={mainVideo ?? undefined} type='video/mp4' />
                                        </video>
                                    </Box>
                                    
                                                         {sharePopup && (
                                <YouTubePopup
                                        isOpen={sharePopup}
                                        onClose={() => { setSharePopup(false); setSelectedPopupItem(null); }}
                                        videoUrl={selectedPopupItem?.videoUrl || mainVideo || ''}
                                        titlePage={photoTalksText ? 'Photo-Talks' : 'Podcast'}
                                        selectedPopupItem={selectedPopupItem}
                                    />    
                                )}
                                    <Box className='videoControls'>
                                        <IconButton onClick={togglePlayPause}>{video.playing ? <Pause /> : <PlayArrow />}</IconButton>
                                        <Slider value={video.progress} onChange={handleSeek} className='videoSlider' />
                                        <Typography variant='body2' className='videoTime'>{formatTime(video.duration)}</Typography>
                                        <IconButton onClick={() => setVideo(v => ({ ...v, fullscreen: true }))}><Fullscreen /></IconButton>
                                        {video.fullscreen && (
                                            <Dialog open={video.fullscreen} onClose={() => setVideo(v => ({ ...v, fullscreen: false }))} maxWidth='lg' fullWidth className='modalContainer'>
                                                <DialogTitle className='closeIconContainer'>
                                                    <IconButton onClick={() => setVideo(v => ({ ...v, fullscreen: false }))} className='closeIconbutton'><CloseIcon /></IconButton>
                                                </DialogTitle>
                                                <DialogContent>
                                                    <Box sx={{ width: '100%', height: '60%', position: 'relative' }}>
                                                        <video controls autoPlay loop className='modalVideo' controlsList='nodownload' style={{ width: '100%' }} ref={videoRef} poster={thumbnail || undefined}>
                                                            <source src={mainVideo ?? undefined} type='video/mp4' />
                                                        </video>
                                                        <Box className='videoHeader'>
                                                            <IconButton onClick={handleDownload}>
                                                                <img src={'/assets/DownloadIcon.svg'} alt='downloadIcon' className='downloadIcon' />
                                                            </IconButton>
                                                        </Box>
                                                       
                                                    </Box>
                                                </DialogContent>
                                            </Dialog>
                                        )}
                                    </Box>
                                </Box>
                               
                            ) : (
                                <Box className='videoUploadCard'>
                                    <CardMedia component='img' image={thumbnail || ''} className={allSearchImages[selectedVideoIndex]?.isGenerated ? 'videoCardImage' : 'blurImage'} />
                                    <div className='videoLoadingContainer'>
                                        {isWsLoading && <CircularProgress size={24} className='videoLoadingIcon' />}
                                    </div>
                                </Box>
                            )}
                            <Box className='videoCardThumbnail'>
                                
                                <Box className='videoThumbnailCard'>
                                    <Box className='videoThumbnailContainer'>
                                       <FluidComponent
                                items={allSearchImages}
                                selectedIndex={selectedVideoIndex}
                                onSelect={(idx: number) => {
                                    handleVideoSearch(allSearchImages[idx]._id);
                                    setSelectedVideoIndex(idx);
                                }}
                                isLoading={websoketResponse}
                                onPromptClick={handleOpenPopup}
                                viewType={viewType}
                                setViewType={setViewType}
                                headingText='Podcast Clips'
                            />
                                    </Box>
                                </Box>
                            </Box>

                            {popupOpen && (
                                <CommonPopup 
                                    open={popupOpen}
                                    onClose={() => { setPopupOpen(false); setSelectedPopupItem(null); }}
                                    leftColumnType='script'
                                    rightColumnType='video'
                                    leftImageSrc={thumbnail || ''}
                                    mainVideo={mainVideo || ''}
                                    script={selectedPopupItem?.inputData?.script || selectedPopupItem?.inputData?.text || ''}
                                    />
                            )}
                            {Array.isArray(scheduledData) && scheduledData.length > 0 && (
                                <ScheduledPopup
                                    open={true}
                                    onClose={() => setScheduledData(null)}
                                    scheduledData={scheduledData}
                                />
                            )}

                            {/* View Popup for YouTube Channel Name and Published Status */}
                            <Dialog open={viewPopupOpen} onClose={() => setViewPopupOpen(false)} >
                                <Box className="PopupHeader">
                                    <IconButton onClick={() => setViewPopupOpen(false)} className="PopupCloseButton">
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                                <DialogTitle>Publish Youtube Info</DialogTitle>
                                <DialogContent>
                                    <Box sx={{ minWidth: 250, p: 1 }}>
                                        {Array.isArray(publishedData) && publishedData.length > 0 ? (
                                            publishedData.map((entry: any, idx: number) => (
                                                <Box key={idx} sx={{ mb: 2 }}>
                                                    <Typography variant="body1" className='videoPromptText'>
                                                        Channel Name:<Typography variant='body1'>{entry.details?.snippet?.channelTitle || entry.channelId || ''}</Typography>
                                                    </Typography>
                                                    <Typography variant="body1" className='videoPromptText'>
                                                        Published Status:<Typography variant='body1'>{entry.status || ''}</Typography>
                                                    </Typography>
                                                    <Typography variant="body1" className='videoPromptText'>
                                                        Published Url: <Typography
                                                            variant="body1"
                                                            className="linkTextyoutube"
                                                            style={{ cursor: entry.youtubeUrl ? 'pointer' : 'default', color: entry.youtubeUrl ? '#1976d2' : undefined }}
                                                            onClick={() => {
                                                                if (entry.youtubeUrl) window.open(entry.youtubeUrl, '_blank');
                                                            }}
                                                        >
                                                            {entry.youtubeUrl || ''}
                                                        </Typography>
                                                    </Typography>
                                                </Box>

                                            ))
                                        ) : (
                                            <Typography variant="body1">No YouTube publish info available.</Typography>
                                        )}
                                    </Box>
                                </DialogContent>
                            </Dialog>
                        </Box>
                    ) : (
                        <Card className='videoPlaceholderCard'>
                            <Box className='videoPlaceholderContent'>
                                <img src={'/assets/ContentVideo.svg'} alt='contentVideo' className='videoPlaceholderIcon' />
                                <Typography variant='body1' className='uploadText'>Create your ideas now.</Typography>
                                <Typography variant='body1' className='uploadText'>Generated videos will appear here</Typography>
                            </Box>
                        </Card>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default PodCast;